var CurrentUser = require("lib/account/CurrentUser");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");
var AltSkillsets = require("lib/academic/AltSkillsets");
var GradeLevel = require("lib/academic/GradeLevel");

class OnboardingStageSelectStandards extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			selectedStandard: null, selectedLiteracyMode: false
		};
	}

	buildOnStandardsSelectF(standardKey) {
		return function() {
			var adminID = CurrentUser.get().id;
			var standardData = { skillset_standard: standardKey, literacy_intention: this.state.selectedLiteracyMode };
			var params = { admin: { prefs: standardData }, global: true };
			CurrentUser.api().patchAdmin(adminID, params, $wr.apiHandler(function(response){
				CurrentUser.fetchCurrentUserData();
				$(window.document).trigger("onboarding-trigger-select-standards");
			}));
			this.props.onComplete({ skillsetStandard: standardKey, literacy_intention: this.state.selectedLiteracyMode });
			Mycroft.newEvent({ category: "Onboarding", action: "standards-selected" });
		}.bind(this);
	}

	getShortGradeLevelRec() {
		var grade = Number(CurrentUser.get().grade_level);
		if (grade < 4) {
			var recText = "Check out the text-to-voice and voice-to-text option for students who aren't yet reading or typing!";
		} else {
			var recText = "Have your students do practice questions while reading longer books to prepare for the quiz!";
		}
		return recText
	}

	onSelectModeType(modeType) {
		if (modeType == LITERACY_MODE) {
			this.setState({ selectedLiteracyMode: true });
			Mycroft.newEvent({ category: "Mode", action: "selected-literacy-mode" });
		} else {
			this.setState({ selectedLiteracyMode: false });	
		}
	}

	render() {
		if (CurrentUser.get().grade_level != "unknown grade") {
			var gradeText = GradeLevel.getName(CurrentUser.get().grade_level);
		}
		var leftContent = (
			<div className="leftCol">
				<div className="onboardingGradeLevelRec">
					<img className="educatorOwl" src={ require("onboarding/teacher-owl.png") } />
					<p className="recHeader">Tips for { gradeText } Teachers</p>
					<div className="recommendation">
						<p>
							{ this.getShortGradeLevelRec() }
						</p>
					</div>
				</div>
			</div>
		);

		var standardOptions = DropDownOptions.Button.Standards({
			buildOptionF: this.buildOnStandardsSelectF,
			showState: true
		});
		var standardSelected = this.state.selectedStandard != undefined;
		var standardsText = standardSelected ? AltSkillsets.getStandardName(this.state.selectedStandard, true) : "Choose";

		var standardsDropdown = (
			<ButtonDropdown text={ standardsText } dropdownDisplay="button"
				className="standardsPicker" buttonClassName="buttonPrimary">
				{ standardOptions }
			</ButtonDropdown>
		);

		var rightContent = (
			<div className="rightCol onboardingLiteracy">
				<p className="onboardingInstructions">
					<span className="instructionTitle">How do you plan on using Whooo's Reading?</span>
				</p>
				<label>
					<input type="radio" checked={ !this.state.selectedLiteracyMode }
							onChange={ this.onSelectModeType.bind(this, ACCOUNTABILITY_MODE) } />
					<span>Accountability & Comprehension</span>
					<p> 
						Whooo’s Reading provides students with quizzes to take after reading 
						books and you get comprehension data back.
					</p>
				</label><br />
				<label>
					<input type="radio" checked={ this.state.selectedLiteracyMode }
							onChange={ this.onSelectModeType.bind(this, LITERACY_MODE) } />
					<span>Thinking & Writing about Literacy</span>
					<p>
						Whooo’s Reading provides thoughtful questions and feedback.
					</p>
				</label><br />
				<p className="onboardingInstructions">
					<span className="instructionTitle">Which standards do you use?</span>
				</p>
				{ standardsDropdown }
			</div>
		);

		return (
			<div className="onboardingStage onboardingStageSelectStandards clearfix">
				{ leftContent }
				{ rightContent }
			</div>
		);
	}

	componentDidMount() {
		CurrentUser.fetchCurrentUserData(function() {
			this.forceUpdate();
		}.bind(this))
	}
}

var ACCOUNTABILITY_MODE = "accountability-mode";
var LITERACY_MODE = "literacy-mode";

OnboardingStageSelectStandards.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	// only used for the final stage of onboarding
	endOnboarding: PropTypes.func,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageSelectStandards;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageSelectStandards.js